export class MetricTypeConstants {
    static HEIGHT = "Height";
    static WEIGHT = "Weight";
    static BMI = "BMI";
    static O2_READING = "Latest SpO2";
    static OXYGEN_SATURATION = "Oxygen Saturation";
    static FEV1  = "FEV1";
    static FEV1_PREDICTED  = "FEV1 Predicted";
    static STS  = "STS";
    static MAX_STS_ALL_TIME  = "Max STS All Time";
    static DIFF_SINCE_LAST_STS  = "Diff Since Last STS";
    static STEPS_COUNT  = "Steps Count";
    static BLOOD_PRESSURE_SYSTOLIC  = "Blood Pressure Systolic";
    static BLOOD_PRESSURE_DIASTOLIC  = "Blood Pressure Diastolic";
    static A1C = "A1C";
    static BLOOD_SUGAR = "Blood Sugar";
    static PEAK_FLOW  = "Peak Flow";
    static PEAK_FLOW_PREDICTED  = "Peak Flow Predicted";
    static EMERGENT_READINGS = "Emergent Readings";
    static URGENT_READINGS = "Urgent Readings";
    static PULSE = "Pulse";
    static HEART_RATE = "Heart Rate";
    static A1C_DIFF_LAST_READING  = "Diff since last reading";
    static ELEVATED_READINGS  = "Elevated Readings";
    static AVERAGE_STEPS_COUNT  = "Steps Count (Avg.)";
    static BEST_FEV1  = "Best FEV1";
    static BEST_PEAK_FLOW  = "Best Peak Flow";
}

export const metricUOM = new Map<string, string>;

metricUOM.set("P_"+MetricTypeConstants.HEIGHT, 'ft');
metricUOM.set("S_"+MetricTypeConstants.HEIGHT, 'inches');
metricUOM.set(MetricTypeConstants.HEIGHT, 'inches');
metricUOM.set(MetricTypeConstants.WEIGHT, 'lbs');
metricUOM.set(MetricTypeConstants.O2_READING, '%');
metricUOM.set(MetricTypeConstants.OXYGEN_SATURATION, '%');
metricUOM.set(MetricTypeConstants.FEV1, 'L');
metricUOM.set(MetricTypeConstants.FEV1_PREDICTED, 'L');
metricUOM.set(MetricTypeConstants.STS, 'reps');
metricUOM.set(MetricTypeConstants.MAX_STS_ALL_TIME, 'reps');
metricUOM.set(MetricTypeConstants.DIFF_SINCE_LAST_STS, 'reps');
metricUOM.set(MetricTypeConstants.STEPS_COUNT, 'steps');
metricUOM.set(MetricTypeConstants.BLOOD_PRESSURE_SYSTOLIC, 'mm/Hg');
metricUOM.set(MetricTypeConstants.BLOOD_PRESSURE_DIASTOLIC, 'mm/Hg');
metricUOM.set(MetricTypeConstants.A1C, '%');
metricUOM.set(MetricTypeConstants.PEAK_FLOW, 'L/min');
metricUOM.set(MetricTypeConstants.PEAK_FLOW_PREDICTED, 'L/min');
metricUOM.set(MetricTypeConstants.PULSE, 'bpm');
metricUOM.set(MetricTypeConstants.HEART_RATE, 'bpm');
metricUOM.set(MetricTypeConstants.BLOOD_SUGAR, 'mg/dL');
metricUOM.set(MetricTypeConstants.EMERGENT_READINGS, 'time(s)');
metricUOM.set(MetricTypeConstants.URGENT_READINGS, 'time(s)');
metricUOM.set(MetricTypeConstants.A1C_DIFF_LAST_READING, '%');
metricUOM.set("P_"+MetricTypeConstants.ELEVATED_READINGS, 'reading');
metricUOM.set("S_"+MetricTypeConstants.ELEVATED_READINGS, 'mm/Hg');
metricUOM.set(MetricTypeConstants.AVERAGE_STEPS_COUNT, 'steps/day');
metricUOM.set(MetricTypeConstants.BEST_FEV1, '%');
metricUOM.set(MetricTypeConstants.BEST_PEAK_FLOW, 'L/min');


export const metricMaxVal = new Map<string, number>;

metricMaxVal.set(MetricTypeConstants.BLOOD_PRESSURE_SYSTOLIC, 125);
metricMaxVal.set(MetricTypeConstants.BLOOD_PRESSURE_DIASTOLIC, 80);